(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-related-collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ss-related-slider')) {
    customElements.define('ss-related-slider', class extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.ss-related-collections__list');
        this.items = [...this.querySelectorAll('.ss-related-collections__item')];
        this.controls = this.querySelector('.ss-related-collections__controls');
        if (!this.list || !this.controls) return;

        this.previous = this.querySelector('[name="previous"]');
        this.next = this.querySelector('[name="next"]');
        this.current = this.querySelector('.slider-counter--current');
        this.total = this.querySelector('.slider-counter--total');
        this.onScroll = () => this.update();
        this.onPrevious = () => this.move(-1);
        this.onNext = () => this.move(1);
        this.list.addEventListener('scroll', this.onScroll, { passive: true });
        this.previous.addEventListener('click', this.onPrevious);
        this.next.addEventListener('click', this.onNext);
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.list);
        this.items.slice(0, 2).forEach(item => this.observer.observe(item));
        this.update();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.list?.removeEventListener('scroll', this.onScroll);
        this.previous?.removeEventListener('click', this.onPrevious);
        this.next?.removeEventListener('click', this.onNext);
      }

      update() {
        const max = Math.max(0, this.list.scrollWidth - this.list.clientWidth);
        const step = this.items.length > 1 ? this.items[1].offsetLeft - this.items[0].offsetLeft : 0;
        const pages = max > 1 && step > 0 ? Math.ceil(max / step) + 1 : 1;
        const position = max - this.list.scrollLeft < 2 ? pages : Math.min(pages, Math.round(this.list.scrollLeft / step) + 1);
        this.controls.hidden = pages === 1;
        this.current.textContent = position;
        this.total.textContent = pages;
        this.previous.disabled = this.list.scrollLeft < 2;
        this.next.disabled = max - this.list.scrollLeft < 2;
      }

      move(direction) {
        const step = this.items[1].offsetLeft - this.items[0].offsetLeft;
        const max = Math.max(0, this.list.scrollWidth - this.list.clientWidth);
        const destination = direction > 0 ? Math.min(max, this.list.scrollLeft + step) : Math.max(0, this.list.scrollLeft - step);
        this.list.scrollTo({ left: destination, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
